import React from 'react'
import Meals from './meal'
import Beverages from './beverages'
import Snacks from './snacks'

function Buy() {
  return (
    <div>
      <Meals/>
      <Beverages/>
      <Snacks/>
    </div>
  )
}

export default Buy